import { FormItem } from '@framework/form';
import { RowElement } from '@framework/ui';
import { IconType } from '../../advanced/buttons/icons/Icons';
import {
  ButtonAlign,
  ButtonType,
} from '../../advanced/buttons/types/ButtonEnums';
import { AlignmentSelectInput } from '../../common/AlignmentSelectInput';
import { ButtonTypeSelectInput } from '../../common/ButtonTypeSelectInput';
import { IconTypeSelectInput } from '../../common/IconTypeSelectInput';

export interface ICommonButtonConfigComponentProps {}

/**
 * Configurazione comune dei bottoni
 */
export function CommonButtonConfigComponent(
  props: ICommonButtonConfigComponentProps,
) {
  return (
    <RowElement>
      <FormItem name="layout.buttonType" label="Tipo di pulsante">
        <ButtonTypeSelectInput
          name="layout.buttonType"
          defaultValue={ButtonType.Primary}
          placeholder="Seleziona il tipo di pulsante"
        />
      </FormItem>
      <FormItem name="layout.iconType" label="Icona del pulsante">
        <IconTypeSelectInput
          name="layout.iconType"
          defaultValue={IconType.Nessuna}
          placeholder="Seleziona l'icona del pulsante"
        />
      </FormItem>
      <FormItem name="layout.buttonAlign" label="Allineamento pulsante">
        <AlignmentSelectInput
          name="layout.buttonAlign"
          defaultValue={ButtonAlign.End}
          placeholder="Seleziona l'allineamento"
        />
      </FormItem>
    </RowElement>
  );
}
